import css from "styled-jsx/css";
import { OPEN_SIGNUP_ITEM_ANIMATION_DURATION } from "./clusters-selection-service";
const TRANSITION = `top ${OPEN_SIGNUP_ITEM_ANIMATION_DURATION}ms ease, bottom ${OPEN_SIGNUP_ITEM_ANIMATION_DURATION}ms ease`;

export const componentStyles = css.global`
  .cluster-selection-one-step-component {
    display: flex;
    flex-direction: column;
    align-items: center;
    user-select: none;

    .first-title {
      margin-top: 65px;
      font-size: 1.75rem;
      font-weight: 700;
    }

    .second-title {
      margin-top: 16px;
      font-size: 0.875rem;
    }

    .cluster-selection-items-wrapper {
      margin-top: 40px;
      position: relative;

      .cluster-selection-item-component-wrapper {
        position: absolute;
        right: 0;
        left: 0;
        z-index: 1;
        transition: ${TRANSITION};
      }
    }
  }
`;
